
import { usePathname } from 'next/navigation';
import { useLocaleFormat } from './useLocaleFormat';

export function usePageChecker() {
  const pathname = usePathname();
  const formatUrl = useLocaleFormat();

  const isCurrentPage = (url) => {
    if (!url) return false;
    return pathname === formatUrl(url);
  };

  return {
    isCurrentPage,
    currentPath: pathname
  };
}